import type { IFieldOptions } from '@axo/form/feature/form-input/types';

export const debtCollectionMonthlyDebtPaymentFieldOptions = {
  registerOptions: {
    deps: 'LoanApplication/Debts.0.OutstandingAmount',

    required: 'error.required',
    valueAsNumber: true,
    min: {
      value: 100,
      message: 'Debt.MonthlyDebtPayment.error.min',
    },
    max: {
      value: 10_000_000,
      message: 'Debt.MonthlyDebtPayment.error.max',
    },
    validate: (value, form) => {
      if (isNaN(value)) return 'error.required';

      const monthlyDebtPayment =
        form['LoanApplication/Debts']?.[0]?.OutstandingAmount;
      if (value >= monthlyDebtPayment) {
        return 'Debt.OutstandingAmount.error.amount';
      }
    },
  },
} satisfies IFieldOptions;
